<template>
  <div class="tools">
    <!-- 标题 -->
    <p title="标题">
      <el-select
        style="width: 90px"
        @change="styleChange(format.header, 'header')"
        size="mini"
        v-model="format.header"
      >
        <el-option
          v-for="header in headerStyleList"
          :key="header.value"
          :label="header.label"
          :value="header.value"
        ></el-option>
      </el-select>
    </p>
    <!-- 字体大小 -->
    <p title="字体大小">
      <el-select
        style="width: 90px"
        @change="styleChange(format.size, 'size')"
        size="mini"
        v-model="format.size"
      >
        <el-option
          v-for="styleItem in fontSizeList"
          :key="styleItem"
          :label="styleItem"
          :value="styleItem"
        ></el-option>
      </el-select>
    </p>
    <!-- 行高 -->
    <p title="行高">
      <img
        v-if="format.lineHeight"
        src="../../../static/images/newCourseImages/hg@2x.png"
        @click="addStyle('lineHeight', format.lineHeight)"
      />
      <!--      <img v-else src="../../../static/images/newCourseImages/scx-1@2x.png" @click="addStyle('lineHeight', format.lineHeight)"/>-->
      <el-select
        style="width: 80px"
        @change="styleChange(format.lineHeight, 'lineHeight')"
        size="mini"
        v-model="format.lineHeight"
      >
        <el-option
          v-for="styleItem in lineHeightList"
          :key="styleItem"
          :label="styleItem"
          :value="styleItem"
        ></el-option>
      </el-select>
    </p>

    <p title="字体颜色">
      <!-- 字体颜色 -->

      <el-popover
        placement="bottom"
        width="150"
        popper-class="colorTools_popper"
        ref="color"
        trigger="click"
      >
        <ul>
          <li
            class="color"
            v-for="color in predefineColors"
            :key="color"
            @click="addColor('color', color)"
          >
            <div style="height: 100%" :style="{ background: color }"></div>
          </li>
        </ul>
        <ul>
          <li
            class="color"
            v-for="color in predefineColors1"
            :key="color"
            @click="addColor('color', color)"
          >
            <div style="height: 100%" :style="{ background: color }"></div>
          </li>
        </ul>
        <ul>
          <li
            class="color"
            v-for="color in predefineColors2"
            :key="color"
            @click="addColor('color', color)"
          >
            <div style="height: 100%" :style="{ background: color }"></div>
          </li>
        </ul>
        <ul>
          <li
            class="color"
            v-for="color in predefineColors3"
            :key="color"
            @click="addColor('color', color)"
          >
            <div style="height: 100%" :style="{ background: color }"></div>
          </li>
        </ul>
        <ul>
          <li
            class="color"
            v-for="color in predefineColors4"
            :key="color"
            @click="addColor('color', color)"
          >
            <div style="height: 100%" :style="{ background: color }"></div>
          </li>
        </ul>
        <ul>
          <li
            class="color"
            v-for="color in predefineColors5"
            :key="color"
            @click="addColor('color', color)"
          >
            <div style="height: 100%" :style="{ background: color }"></div>
          </li>
        </ul>
        <span
          title="字体色"
          style="cursor: pointer"
          slot="reference"
          class="el-icon-edit"
          @click="addColor('color', format.color)"
          :style="{ color: format.color }"
        ></span>
        <!--        <i style="cursor: pointer;" slot="reference" class="el-icon-arrow-down"></i>-->
      </el-popover>

      <!-- 背景色  -->

      <el-popover
        placement="bottom"
        width="150"
        popper-class="colorTools_popper"
        ref="background"
        trigger="click"
      >
        <ul>
          <li
            class="color"
            v-for="color in predefineColors"
            :key="color"
            @click="addColor('background', color)"
          >
            <div style="height: 100%" :style="{ background: color }"></div>
          </li>
        </ul>
        <ul>
          <li
            class="color"
            v-for="color in predefineColors1"
            :key="color"
            @click="addColor('background', color)"
          >
            <div style="height: 100%" :style="{ background: color }"></div>
          </li>
        </ul>
        <ul>
          <li
            class="color"
            v-for="color in predefineColors2"
            :key="color"
            @click="addColor('background', color)"
          >
            <div style="height: 100%" :style="{ background: color }"></div>
          </li>
        </ul>
        <ul>
          <li
            class="color"
            v-for="color in predefineColors3"
            :key="color"
            @click="addColor('background', color)"
          >
            <div style="height: 100%" :style="{ background: color }"></div>
          </li>
        </ul>
        <ul>
          <li
            class="color"
            v-for="color in predefineColors4"
            :key="color"
            @click="addColor('background', color)"
          >
            <div style="height: 100%" :style="{ background: color }"></div>
          </li>
        </ul>
        <ul>
          <li
            class="color"
            v-for="color in predefineColors5"
            :key="color"
            @click="addColor('background', color)"
          >
            <div style="height: 100%" :style="{ background: color }"></div>
          </li>
        </ul>
        <span
          class="backgroundColor"
          @click="addColor('background', format.background)"
          :style="{ background: format.background }"
          style="cursor: pointer"
          slot="reference"
          title="背景色"
        ></span>
        <!--        <i style="cursor: pointer;" slot="reference" class="el-icon-arrow-down"></i>-->
      </el-popover>
    </p>
    <!-- 字体样式 -->
    <p title="字体样式">
      <img
        title="加粗"
        v-if="format.bold"
        src="../../../static/images/newCourseImages/jc-2@2x.png"
        @click="addStyle('bold', false)"
      />
      <img
        title="加粗"
        v-else
        src="../../../static/images/newCourseImages/jc-1@2x.png"
        @click="addStyle('bold', true)"
      />
      <img
        title="斜体"
        v-if="format.italic"
        src="../../../static/images/newCourseImages/qx-2@2x.png"
        @click="addStyle('italic', false)"
      />
      <img
        title="斜体"
        v-else
        src="../../../static/images/newCourseImages/qx-1@2x.png"
        @click="addStyle('italic', true)"
      />
      <img
        title="下划线"
        v-if="format.underline"
        src="../../../static/images/newCourseImages/xhx-2@2x.png"
        @click="addStyle('underline', false)"
      />
      <img
        title="下划线"
        v-else
        src="../../../static/images/newCourseImages/xhx-1@2x.png"
        @click="addStyle('underline', true)"
      />
      <img
        title="穿插线"
        v-if="format.strike"
        src="../../../static/images/newCourseImages/scx-2@2x.png"
        @click="addStyle('strike', false)"
      />
      <img
        title="穿插线"
        v-else
        src="../../../static/images/newCourseImages/scx-1@2x.png"
        @click="addStyle('strike', true)"
      />
    </p>
    <p title="代码块">
      <svg
        v-if="format['code-block']"
        style="
          width: 16px;
          height: 16px;
          vertical-align: -0.15em;
          margin: 0 6px;
        "
        class="icon svg-icon isactive"
        aria-hidden="true"
        @click="addStyle('code-block', false)"
      >
        <use xlink:href="#icon-daima"></use>
      </svg>
      <svg
        v-else
        style="
          width: 16px;
          height: 16px;
          vertical-align: -0.15em;
          margin: 0 6px;
        "
        class="icon svg-icon"
        aria-hidden="true"
        title="代码块"
        @click="addStyle('code-block', true)"
      >
        <use xlink:href="#icon-daima"></use>
      </svg>

      <img
        title="链接"
        v-if="format.link"
        src="../../../static/images/newCourseImages/link-1@2x.png"
        @click="addStyle('link', false)"
      />
      <img
        title="链接"
        v-else
        src="../../../static/images/newCourseImages/link@2x.png"
        @click="addStyle('link', true)"
      />

      <img
        title="插入图片"
        src="../../../static/images/newCourseImages/tp@2x.png"
        @click="addStyle('image', true)"
      />

      <span
        title="清除样式"
        class="el-icon-discount"
        @click="addStyle('clean', true)"
      ></span>
    </p>
    <!-- 对齐方式 -->
    <p title="对齐方式">
      <img
        title="左对齐"
        v-if="format.align === 'justify'"
        src="../../../static/images/newCourseImages/zdq-2@2x.png"
        @click="addStyle('align', 'justify')"
      />
      <img
        title="左对齐"
        v-else
        src="../../../static/images/newCourseImages/zdq-1@2x.png"
        @click="addStyle('align', 'justify')"
      />
      <img
        title="居中对齐"
        v-if="format.align === 'center'"
        src="../../../static/images/newCourseImages/jz-2@2x.png"
        @click="addStyle('align', 'center')"
      />
      <img
        title="居中对齐"
        v-else
        src="../../../static/images/newCourseImages/jz-1@2x.png"
        @click="addStyle('align', 'center')"
      />
      <img
        title="右对齐"
        v-if="format.align === 'right'"
        src="../../../static/images/newCourseImages/y-2@2x.png"
        @click="addStyle('align', 'right')"
      />
      <img
        title="右对齐"
        v-else
        src="../../../static/images/newCourseImages/y-1@2x.png"
        @click="addStyle('align', 'right')"
      />
    </p>
  </div>
</template>

<script>
import bus from "@/vendor/eventbus";

export default {
  name: "tools",
  props: {
    myRef: {
      type: String,
      default: "zlEditor",
    },
  },
  data() {
    return {
      headerStyleList: [
        {
          label: "标题一",
          value: 1,
        },
        {
          label: "标题二",
          value: 2,
        },
        {
          label: "标题三",
          value: 3,
        },
        {
          label: "标题四",
          value: 4,
        },
        {
          label: "标题五",
          value: 5,
        },
        {
          label: "文本",
          value: 0,
        },
      ],
      fontList: [
        {
          label: "标准字体",
          value: false,
        },
        {
          label: "衬线字体",
          value: "serif",
        },
        {
          label: "等宽字体",
          value: "monospace",
        },
      ],
      fontSizeList: [
        "10px",
        "12px",
        "13px",
        "14px",
        "16px",
        "18px",
        "20px",
        "22px",
        "24px",
        "28px",
        "32px",
      ],
      lineHeightList: ["initial", "1", "1.5", "1.75", "2", "3", "4", "5"],
      predefineColors: ["#ffffff", "#C0C4CC", "#909399", "#606266", "#000000"],
      predefineColors1: ["#fef0f0", "#fde2e2", "#F56C6C", "#ff0000"],
      predefineColors2: ["#ecf5ff", "#c6e2ff", "#79bbff", "#409EFF", "#0000ff"],
      predefineColors3: ["#fdf6ec", "#faecd8", "#FFD700", "#E6A23C", "#FFFF00"],
      predefineColors4: ["#f0f9eb", "#e1f3d8", "#00ff00", "#67C23A"],
      predefineColors5: ["#CCFFFF", "#99FFFF", "#66FFFF", "#33FFFF", "#00FFFF"],
      // 2021.8.3 样式集合
      format: {
        font: false, //字体
        color: "", //字体颜色
        background: "", //背景色
        size: "", // 字体大小
        lineHeight: "initial", // 行高
        header: 0, //  标题
        bold: false, //  加粗
        italic: false, //  斜体
        underline: false, //  下划线
        strike: false, //  穿插线
        link: false, //  穿插线
        align: "", //  文本位置  center  right  justify
      },
    };
  },
  watch: {},
  mounted() {
    bus.$on(this.myRef, this.init);
  },
  methods: {
    init(format) {
      this.format = {
        font: false, //字体
        color: "", //字体颜色
        background: "", //背景色
        size: "", // 字体大小
        lineHeight: "initial", // 行高
        header: 0, //  标题
        bold: false, //  加粗
        italic: false, //  斜体
        underline: false, //  下划线
        strike: false, //  穿插线
        link: false, //  穿插线
        align: "", //  文本位置  center  right  justify
      };
      for (const o in format) {
        if (format[o].constructor === Array) {
          this.$set(this.format, o, format[o][0]);
        } else {
          this.$set(this.format, o, format[o]);
        }
      }
    },
    addStyle(prop, val) {
      bus.$emit(this.myRef + "addStyle", prop, val);
      this.$set(this.format, prop, val);
    },
    styleChange(val, type) {
      bus.$emit(this.myRef + "addStyle", type, val);
      this.$set(this.format, type, val);
    },
    // 设置颜色
    addColor(prop, val) {
      this.addStyle(prop, val);
      this.$refs[prop].showPopper = false;
    },
  },
};
</script>

<style scoped lang="scss">
.tools {
  display: flex;
  flex-wrap: wrap;
  max-height: 28px;
  overflow: hidden;
  transition: all 0.3s ease;

  p {
    display: flex;
    align-items: center;

    img,
    span {
      display: inline-block;
      margin: 0 6px;
      width: 16px;
      height: 16px;
      cursor: pointer;
      font-weight: 600;
      font-size: 16px;
    }

    .backgroundColor {
      display: inline-block;
      height: 15px;
      width: 15px;
      background: #ffffff;
      border: solid 0.5px red;
      margin: 0 4px;
      cursor: pointer;
    }
  }
}
svg{
  cursor: pointer;
}
.colorTools_popper {
  user-select: none;

  ul {
    display: flex;
    flex-wrap: wrap;

    .color {
      width: 15px;
      height: 15px;
      margin: 1px;
      border: solid 0.5px #ffffff;
      cursor: pointer;
      padding: 1px;

      &:hover {
        border: solid 0.5px red;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/zl-editor/tools.vue